import {combineReducers} from "redux";

export function error(state = null, action) {
    switch (action.type) {
        case "MEMBER_LIST_ERROR":
            return action.error;

        case "MEMBER_LIST_RESET":
            return null;

        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case "MEMBER_LIST_LOADING":
            return action.loading;

        case "MEMBER_LIST_RESET":
            return false;

        default:
            return state;
    }
}

export function retrieved(state = null, action) {
    switch (action.type) {
        case "MEMBER_LIST_SUCCESS":
            return action.retrieved;

        case "MEMBER_LIST_RESET":
            return null;

        default:
            return state;
    }
}

export function requestCountError(state = null, action) {
    switch (action.type) {
        case "MEMBER_LIST_REQUEST_COUNT_ERROR":
            return action.error;

        default:
            return state;
    }
}

export function requestCountLoading(state = false, action) {
    switch (action.type) {
        case "MEMBER_LIST_REQUEST_COUNT_LOADING":
            return action.loading;

        default:
            return state;
    }
}

export function requestCountRetrieved(state = null, action) {
    switch (action.type) {
        case "MEMBER_LIST_REQUEST_COUNT_SUCCESS":
            return action.retrieved;

        default:
            return state;
    }
}

export default combineReducers({error, loading, retrieved, requestCountError, requestCountLoading, requestCountRetrieved});
